module.exports = __webpack_public_path__ + "egg.jpg?38a5f81ba14449a06ab4154415e2af5e";